import { Embedder } from "@vviinn/user-managment-client-ts";

import { AIMethodsTitles } from "../types";
import { valueToTitle } from "../../helpers";

export const embedderTitleToAiTitle = (embedderTitle: Embedder) =>
  `include${valueToTitle(embedderTitle)}Features`.replaceAll(
    " ",
    "",
  ) as keyof AIMethodsTitles;
